export default function PosCartIcon({ className = "cursor-pointer" }: { className?: string }) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="10" fill="#F7F7F7" />
      <path
        d="M11.5 12.5H13.0585C13.7542 12.5 14.1021 12.5 14.364 12.6888C14.6258 12.8775 14.7358 13.2075 14.9558 13.8675L15.5 15.5"
        stroke="#7F7F7F"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 25.5H16.0509C15.9047 25.5 15.8316 25.5 15.7762 25.4938C15.1886 25.428 14.786 24.8695 14.9094 24.2913C14.9211 24.2367 14.9442 24.1674 14.9904 24.0287V24.0287C15.0418 23.8747 15.0674 23.7977 15.0958 23.7298C15.3861 23.0342 16.0428 22.5608 16.7945 22.5054C16.8679 22.5 16.9491 22.5 17.1114 22.5H22.5"
        stroke="#7F7F7F"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M22.1787 22.5H19.1376C17.8584 22.5 17.2188 22.5 16.7178 22.1697C16.2169 21.8394 15.9649 21.2515 15.461 20.0757L15.2922 19.6818C14.4827 17.7929 14.0779 16.8485 14.5225 16.1743C14.9672 15.5 15.9946 15.5 18.0496 15.5H23.3305C25.6295 15.5 26.779 15.5 27.2126 16.2471C27.6462 16.9942 27.0758 17.9923 25.9352 19.9884L25.6517 20.4846C25.0897 21.4679 24.8088 21.9596 24.3432 22.2298C23.8776 22.5 23.3113 22.5 22.1787 22.5Z"
        stroke="#7F7F7F"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="25" cy="28" r="1" fill="#7F7F7F" />
      <circle cx="17" cy="28" r="1" fill="#7F7F7F" />
    </svg>
  );
}
